import React from 'react';
import chef from '../../images/chef.jpg';
import svgcook from '../../svg/svg-cook.svg';
import {useTranslation } from "react-i18next"; 

function Chefs() {
  const { t, i18n } = useTranslation();
    return (
        <section id="chefs" className="chefs">
        <div className="container" >
          <div className="section-title">
            <h2>Chef</h2>
            <p>{t("talented-chef")} <img className='i-cook' src={svgcook} alt="Chef Old Tbilisi"/></p>
          </div>    
          <div className="row center">
            <div className="col-md-4">
              <div className="member"  >
                <img src={chef} className="img-fluid" alt="Chef of Old Tbilisi restaurant"/>
                <div className="member-info">
                  <div className="member-info-content">
                    <h4>{t("chef-desc-h")}</h4>
                    <span>{t("chef-desc-p")}</span>
                  </div>
                  <div className="social">                 
                    <a href="https://www.facebook.com/oldtbilisi2021/" target="_blank" rel="noreferrer">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://www.instagram.com/old_tbilisii/" target="_blank" rel="noreferrer">
                      <i className="fab fa-instagram"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div>
              <h2 className="chef-description pb-3">
              {t("tc-p-1")}
              </h2>   
              </div>
              
            </div>
   
    
          </div>
    
    
    
        </div>
      </section>
    )
}

export default Chefs;
